var millisecond = 1;
var second = 1000;
var minute = 60000;
var hour = minute * 60;
var day = hour * 24;
var week = day * 7;
var units = [{
  label: 'just now',
  value: minute
}, {
  label: 'm ago',
  value: hour
}, {
  label: 'h ago',
  value: day
}];
var relatedDate = function relatedDate(date) {
  var today = new Date();
  var inputDate = new Date(date);
  var diff = Math.abs(today.valueOf() - inputDate.valueOf());
  if (diff < minute) {
    return units[0].label;
  }
  for (var i = 1; i < units.length; i++) {
    if (diff < units[i].value) {
      var result = Math.floor(diff / units[i - 1].value);
      return "".concat(result).concat(units[i].label);
    }
  }
  var currentYear = today.getFullYear();
  var dateYear = inputDate.getFullYear();
  var showYear = currentYear !== dateYear;
  return formatDate(date, showYear);
};
var toDate = function toDate(date) {
  return new Date(date);
};
var fullDateToString = function fullDateToString(date) {
  return toDate(date).toLocaleString();
};
var formatDate = function formatDate(date) {
  var showYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var showTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var locales = 'en-GB';
  var internalDate = typeof date === 'string' ? new Date(date) : date;
  var dateString = internalDate.toLocaleDateString(locales, {
    day: 'numeric',
    month: 'short',
    year: showYear ? 'numeric' : undefined
  });
  if (!showTime) {
    return dateString;
  } else {
    var timeString = internalDate.toLocaleTimeString(locales, {
      hour: '2-digit',
      minute: '2-digit'
    });
    return "".concat(dateString, " ").concat(timeString);
  }
};

export { day, formatDate, fullDateToString, hour, millisecond, minute, relatedDate, second, week };
